/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from '@codegrade/maybe';
import { expr } from '@codegrade/utils';
import { emptyVNode } from './vue';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const { ifExpr, caseExpr } = expr;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function ifOrEmpty(cond, then) {
    if (cond) {
        return then();
    }
    return emptyVNode();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function ifJustOrEmpty(maybe, then) {
    return maybe.caseOf({
        Just: then,
        Nothing: emptyVNode,
    });
}
/**
 * Conditionally render something for a nullable value, otherwise render emptyVNode.
 *
 * @param nullableValue The nullable value.
 * @param then A function that takes the non-nullable type of value and renders something.
 * @returns An empty VNode or the nodes you want to render.
 */
export function emptyIfNil(nullableValue, then) {
    return Maybe.fromNullable(nullableValue).caseOf({
        Just: then,
        Nothing: emptyVNode,
    });
}
